// extracted by mini-css-extract-plugin
export default {"btn":"ButtonMain_btn__W2LVo"};